import { IFileOptions, IFileParameterSet, IFileService } from "./PA.File.IF";
import { PAEnvironment } from "../PA.Core/PAEnvironment";
import axios from "axios";
import { BehaviorSubject } from "rxjs";

export class PAFile implements IFileService {

    private _OnDownloadCompleted: BehaviorSubject<IFileService>;

    constructor() {
        this._OnDownloadCompleted = new BehaviorSubject<IFileService>(this);
    }

    get OnDownloadCompleted(): BehaviorSubject<IFileService> {
        return this._OnDownloadCompleted;
    }

    downloadFile(wbFileId): Promise<string> {
        const self = this;

        return new Promise<string>((resolve, reject) => {

            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
            if (sEndPoint.endsWith("/"))
                sEndPoint += "download";
            else
                sEndPoint += "/download";

            window.location.href = encodeURI(sEndPoint + "?params=" + wbFileId);
        });
    }

    uploadFile(aFile: File, aFileParamSet: IFileParameterSet, aFileOptions: IFileOptions): Promise<string> {
        const self = this;
        let formData = new FormData();
        formData.append("file", aFile, aFile.name);
        let params = {
            method: "uploadFile",
            fileOptions: aFileOptions,
            fileParamSet: aFileParamSet
        };
        return new Promise<string>((resolve, reject) => {
            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
            if (sEndPoint.endsWith("/"))
                sEndPoint += "upload";
            else
                sEndPoint += "/upload";
            axios.post(sEndPoint, formData, {
                params,
                headers: { "CONTENT-TYPE": "multipart/form-data" }
            })
                .then((resp: any) => {
                    if (resp.status == 200) {
                        var responseData = "file uploaded";
                        resolve(responseData);
                    } else {
                        reject("Unable to upload the file. ");
                    }
                })
                .catch((err: any) => {
                    reject("Unable to upload the file. " + err);
                });

        });
    }
}